export default __webpack_public_path__ + "static/media/M15.235f811e.jpg";